import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
Backward-compatible redirect for the retired `/teams/:teamId/jobs` and
`/teams/:teamId/projects/:projectId/jobs` routes (bookmarks, external links) - the real page is now
the single `/jobs` route, scoped via `teamId`/`projectId` query parameters.
*/
const JobsRouteRedirect: React.FC = () => {
  const { teamId, projectId } = useParams<{ teamId?: string; projectId?: string }>();
  const searchParameters = new URLSearchParams();
  if (teamId) searchParameters.set("teamId", teamId);
  if (projectId) searchParameters.set("projectId", projectId);
  return <Navigate to={`/jobs?${searchParameters.toString()}`} replace />;
};

export default JobsRouteRedirect;
